import React, { useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import CommentOutline from '@wix/da-ds/pkg/Icons/24x24/CommentOutline';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarToggleButton from '../../_partials/items/ActionBarToggleButton';
import ActionBarButtonRestricted from '../../_partials/ActionBarButtonRestricted';
const CommentButton = ({ deviation, deviation: { extended }, onToggleCommentPanel, isCommentPanelOpen, isOwner, actionBarType })=>{
    var _deviation_author;
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    const onClick = useCallback(()=>{
        if (!extended) {
            return;
        }
        onToggleCommentPanel(deviation, actionBarType);
    }, [
        extended,
        onToggleCommentPanel,
        deviation,
        actionBarType
    ]);
    var _deviation_author_useridUuid;
    return /*#__PURE__*/ React.createElement(ActionBarButtonRestricted, {
        subscribersOnly: true,
        deviation: deviation,
        tooltip: isOwner ? t('actionbar.comment') : undefined,
        button: /*#__PURE__*/ React.createElement(ActionBarToggleButton, {
            activated: isCommentPanelOpen,
            onClick: onClick,
            "data-hook": BiDataHook.DEVIATION_COMMENT_BUTTON,
            icon: CommentOutline,
            label: isOwner || isMobile ? undefined : t('actionbar.comment.label'),
            biData: BiData({
                evid: 105,
                typeid: getDeviationResourceType(deviation),
                itemid: deviation.deviationId,
                creatorid: (_deviation_author_useridUuid = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid) !== null && _deviation_author_useridUuid !== void 0 ? _deviation_author_useridUuid : '',
                sectionname: BiContextProvidedValue,
                sectionid: BiContextProvidedValue,
                section_typeid: BiContextProvidedValue,
                sectiontype: BiContextProvidedValue,
                sectionrank: BiContextProvidedValue,
                rank: BiContextProvidedValue,
                sort_type: BiContextProvidedValue,
                reason_shown: BiContextProvidedValue,
                widgetname: BiContextProvidedValue
            })
        })
    });
};
CommentButton.displayName = 'CommentButton';
export default CommentButton;
